import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { scrollToSection } from '../lib/scroll';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 relative">
            <img
              src="/images/logo-horizontal-negro.png"
              alt="Andes Metal"
              className={`h-8 sm:h-10 transition-opacity duration-300 ${
                isScrolled ? 'opacity-100' : 'opacity-0'
              }`}
            />
            <img
              src="/images/logo-horizontal-blanco.png"
              alt="Andes Metal"
              className={`h-8 sm:h-10 absolute top-0 left-0 transition-opacity duration-300 ${
                isScrolled ? 'opacity-0' : 'opacity-100'
              }`}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleNavClick('inicio')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-brand ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => handleNavClick('nosotros')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-brand ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Nosotros
            </button>
            <button
              onClick={() => handleNavClick('servicios')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-brand ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => handleNavClick('contacto')}
              className={`px-6 py-2 rounded-md font-medium transition-all duration-300 ${
                isScrolled
                  ? 'bg-brand text-white hover:bg-brand-dark'
                  : 'bg-white text-brand hover:bg-gray-100'
              }`}
            >
              Contacto
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-md ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <button
              onClick={() => handleNavClick('inicio')}
              className="text-left text-gray-700 hover:text-brand font-medium"
            >
              Inicio
            </button>
            <button
              onClick={() => handleNavClick('nosotros')}
              className="text-left text-gray-700 hover:text-brand font-medium"
            >
              Nosotros
            </button>
            <button
              onClick={() => handleNavClick('servicios')}
              className="text-left text-gray-700 hover:text-brand font-medium"
            >
              Servicios
            </button>
            <button
              onClick={() => handleNavClick('contacto')}
              className="text-left bg-brand text-white px-6 py-2 rounded-md hover:bg-brand-dark font-medium"
            >
              Contacto
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
